import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

import { ROUTES } from 'config/constants';

import { handleFetchSingpassData } from 'redux/reducers/auth';

import TabMenu from 'components/TabMenu/TabMenu';

import SingpassVerifiedImg from 'assets/images/singpass-verified.png';
import SingpassUnverifiedImg from 'assets/images/singpass-unverified.png';
import { ReactComponent as WarningIcon } from 'assets/images/general/ic-warning-outline-black.svg';

import './AccountNav.scss';

const AccountNav = ({
    tabMenu,
    singPassVerified,
    isSingPassVerified,
    isSingPassExpired
}) => {
    const dispatch = useDispatch();
    const { profile } = useSelector(state => ({ profile: state.auth.profile }));
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;

    useEffect(() => {
        if (singPassVerified !== 'rejected' && !profile.singpass) {
            dispatch(handleFetchSingpassData());
        }
    }, [dispatch, profile.singpass, singPassVerified]);

    const getActiveMenu = () => {
        const find = tabMenu.find((e) => e.isActive);

        if (find) {
            return (
                <TabMenu
                    isActive={find.isActive}
                    text={find.name}
                    icon={find.icon}
                    onclick={() => find.onClick()}/>
            );
        }

        return '';
    };

    return (
        <>
            <div className='account-nav'>
                <div className='account-nav__container'>
                    <div className='account-nav__header'>
                        <div className='account-nav__account-name fs-exclude'>
                            {profile
                                ? profile?.singpass
                                    ? profile?.singpass?.legal_name
                                    : profile?.name
                                : ''}
                        </div>
                        <p className='account-nav__account-email fs-exclude'>
                            {profile.email}
                        </p>
                        {isMobile && <div className='d-flex account-nav__list__singpass'>
                            <span className={singPassVerified && isSingPassExpired ? 'account-nav__text-red' : ''}>{`Singpass ${isSingPassVerified && !isSingPassExpired ? 'verified' : isSingPassExpired ? 'expired' : 'unverified'}`}</span>
                            {singPassVerified && isSingPassExpired ? (
                                <WarningIcon className='account-nav__ic-warning' />
                            ) : (
                                <img src={singPassVerified ? SingpassVerifiedImg : SingpassUnverifiedImg} alt=''/>
                            )}
                        </div>}
                    </div>
                    <div className='account-nav__list'>
                        {isSingPassVerified && (
                            <div className='account-nav__list__active'>
                                {getActiveMenu()}
                            </div>
                        )}
                        <Collapse isOpen={true}>
                            {!isMobile && <div className='d-flex account-nav__list__singpass'>
                                <span className={singPassVerified && isSingPassExpired ? 'account-nav__text-red' : ''}>{`Singpass ${isSingPassVerified && !isSingPassExpired ? 'verified' : isSingPassExpired ? 'expired' : 'unverified'}`}</span>
                                {singPassVerified && isSingPassExpired ? (
                                    <WarningIcon className='account-nav__ic-warning' />
                                ) : (
                                    <img src={singPassVerified ? SingpassVerifiedImg : SingpassUnverifiedImg} alt=''/>
                                )}
                            </div>}
                            {tabMenu.map((item, i) => {
                                if (isSingPassVerified) {
                                    if (isMobile) {
                                        if (!item.isActive) {
                                            return (
                                                <TabMenu
                                                    isActive={item.isActive}
                                                    key={i}
                                                    text={item.name}
                                                    icon={item.icon}
                                                    onclick={() => item.onClick()}/>
                                            );
                                        }
                                    } else {
                                        return (
                                            <TabMenu
                                                isActive={item.isActive}
                                                key={i}
                                                text={item.name}
                                                icon={item.icon}
                                                onclick={() => item.onClick()}/>
                                        );
                                    }
                                } else {
                                    return (
                                        (
                                            item.type === ROUTES.MYINFORMATION ||
                                            item.type === ROUTES.REFER_AND_EARN
                                        ) && (
                                            <TabMenu
                                                isActive={item.isActive}
                                                key={i}
                                                text={item.name}
                                                icon={item.icon}
                                                onclick={() => item.onClick()}/>
                                        )
                                    );
                                }

                                return true;
                            })}
                        </Collapse>
                    </div>
                </div>
            </div>
        </>
    );
};

AccountNav.propTypes = {
    tabMenu: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    singPassVerified: PropTypes.string.isRequired,
    isSingPassVerified: PropTypes.bool.isRequired,
    isSingPassExpired: PropTypes.bool
};

export default AccountNav;
